import React from 'react';
import LearningCard from '../components/LearningCard';

const PrivateSaleHosts = () => (
  <LearningCard
    testid="private-sale-hosts"
    title="Private Sale – Village Hosts"
    subtitle="Microlearning"
    support="Open hier de Nederlandstalige microlearning voor hosts over membership, guest approach en de Private Sale activatie."
    buttons={[
      {
        label: 'Open de microlearning',
        href: 'https://app.qoldo.com/p/173e0cc4-9c3b-427e-a918-970db235c690?t=ba932785-881e-4d14-98da-4106b6b8631e',
        testid: 'btn-open-microlearning',
      },
    ]}
  />
);

export default PrivateSaleHosts;
